class FilterTypeHouse {
    constructor(el) {
        if(!el) return;
        el.$controller = this;
        this.el = el;
        this.inputs = Array.from(el.querySelectorAll('input'));
        this.activeEL = el.querySelector('.FilterTypeHouse__active');
        this.items = Array.from(el.querySelectorAll('.FilterTypeHouse__item'));
        /*this.items.forEach((item) => {
            item.addEventListener('click', () => {
                this.handleSelect(item);
            });
        });*/
        this.groups = this.items.reduce((tmp, item) => {
            const group = item.dataset.group;
            if (!tmp[group]) {
                tmp[group] = item.querySelector('img').outerHTML;
            }
            return tmp;
        }, {});
        if(this.activeEL) {
            this.activeEL.addEventListener('click', () => this.toggle())
        }

        el.addEventListener('mouseenter', open);
        this.inputs.forEach((input) => {
            input.addEventListener('change', (e) => {
                if (e instanceof CustomEvent) return;
                const item = input.closest('.FilterTypeHouse__item');
                if (item) {
                    this.handleSelect(item);
                }
            });
        });

        window.filtersSendRemove = this.sendRemove;
    }

    checkNull(input, item) {
        console.log('checknull', this.inputs.every((input) => !input.checked));

        if (this.inputs.every((input) => !input.checked)) {

            const groupName = item.dataset.group;
            this.items.forEach((item) => {
                if(item.dataset.group === groupName) {
                    item.querySelector('input').checked = true;
                    this.handleSelect(item);
                }
            })

        }
    }

    setActive(item) {
        if (item.dataset.group !== this.activeEL.dataset.group) {
            this.activeEL.dataset.group = item.dataset.group;
            this.inputs.forEach((input) => {
                if (input.checked && !item.contains(input)) {
                    input.checked = false;
                    input.dispatchEvent(new CustomEvent('change'));
                    this.sendRemove(input);
                }
            });
        }
    }

    sendRemove(input) {
        document.dispatchEvent(new CustomEvent('main-filter-change', {
            detail: {
                name: input.name,
                value: input.value,
                remove: true,
            },
        }));
    }

    handleSelect(item) {
        const input = item.querySelector('input');
        if (input.checked) {
            document.dispatchEvent(new CustomEvent('main-filter-change', {
                detail: {
                    name: input.name,
                    value: input.value,
                    change: true,
                },
            }));
            this.setActive(item);
        } else {
            document.dispatchEvent(new CustomEvent('main-filter-change', {
                detail: {
                    name: input.name,
                    value: input.value,
                    remove: true,
                },
            }));
            this.checkNull(input, item);
        }
        this.activeEL.innerHTML = this.getActiveHtml();
    }

    getValues() {
        return this.inputs.filter(input => input.checked).map(input => input.value);
    }

    getActiveInfo() {
        const inputs = this.inputs.filter(input => input.checked);
        this.el.dispatchEvent(new CustomEvent('select', { detail: this.getValues() }));
        if (inputs.length) {
            const item = inputs[0].closest('.FilterTypeHouse__item');
            const group = item.dataset.group;
            if (inputs.length === 1) {
                return {
                    value: item.innerText,
                    image: item.querySelector('img').outerHTML,
                    group,
                }
            } else {
                return {
                    value: group,
                    image: this.groups[group],
                    group,
                }
            }
        }
        return {};
    }

    getActiveHtml() {
        const { value, image } = this.getActiveInfo();
        return `${image || ''}<span>${value || '-'}</span>`;
    }

    open() {
        this.toggle(false);
        this.el.addEventListener('mouseleave', close, { once: true });
    }

    close() {
        this.toggle(false);
    }

    toggle(isOpen) {
        const result = this.el.classList.toggle('FilterTypeHouse--active', isOpen);
        if (result) {
            ClickOutside.addListener(this.el, () => this.close());
        } else {
            ClickOutside.removeListener(this.el);
        }
    }
}

document.querySelectorAll('.FilterTypeHouse').forEach((el) => {
    new FilterTypeHouse(el);
});

